/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ProInputs */

const en_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const ar_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احترافي`)
};

const de_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const es_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const fr_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const it_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const ja_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const ko_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const pt_br_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const ru_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const th_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`โปร`)
};

const tr_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro`)
};

const zh_cn_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`专业版`)
};

const zh_tw_pro = /** @type {(inputs: ProInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`專業版`)
};

/**
* | output |
* | --- |
* | "Pro" |
*
* @param {ProInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro = /** @type {((inputs?: ProInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ProInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro(inputs)
	if (locale === "ar") return ar_pro(inputs)
	if (locale === "de") return de_pro(inputs)
	if (locale === "es") return es_pro(inputs)
	if (locale === "fr") return fr_pro(inputs)
	if (locale === "it") return it_pro(inputs)
	if (locale === "ja") return ja_pro(inputs)
	if (locale === "ko") return ko_pro(inputs)
	if (locale === "pt_br") return pt_br_pro(inputs)
	if (locale === "ru") return ru_pro(inputs)
	if (locale === "th") return th_pro(inputs)
	if (locale === "tr") return tr_pro(inputs)
	if (locale === "zh_cn") return zh_cn_pro(inputs)
	return zh_tw_pro(inputs)
});